// save_draft answers 207 with one result per draft sent, in the order sent: {status: "created" | "updated", uuid}
// for a saved one, {status: "error", code, detail} for a refused one. A refusal is not a success: the page must
// stay, with the drafts that were not saved. Codes (errors.<code> says each):
// - permission_denied, move_not_allowed, passage_other_folder, exam_folder, subject_mismatch, not_found: no rights
//   or not that folder;
// - not_a_draft: a question of an exam's subject that is already in review is changed in its own editor, not
//   saved as a draft again;
// - draft_not_own: someone else's draft in a subject (only its author changes and submits it);
// - draft_required: nothing to save (an empty draft).

// The refusal's code as a string (a list of codes gives its first).
export const draftErrorCode = (result) => {
  const code = Array.isArray(result?.code) ? result.code[0] : result?.code;
  return typeof code === "string" ? code : null;
};

// The refused results, each with its 0-based `index` among the drafts sent.
export const failedDrafts = (results) =>
  (Array.isArray(results) ? results : [results])
    .map((result, index) => ({ ...result, index }))
    .filter((result) => result?.status === "error");

// The indexes of the drafts that were saved.
export const savedDraftIndexes = (results) =>
  new Set(
    (Array.isArray(results) ? results : [results])
      .map((result, index) => (result && result.status !== "error" ? index : -1))
      .filter((index) => index >= 0)
  );

// "Not saved: question 2 — <reason>" (one draft: just the reason), the reason translated by its code.
export const draftFailureMessage = (t, failed, total) => {
  const reason = (item) => {
    const fallback = (typeof item.detail === "string" && item.detail) || t("my_questions.toasts.something_went_wrong");
    const code = draftErrorCode(item);
    return code ? t(`errors.${code}`, { defaultValue: fallback }) : fallback;
  };
  if (total <= 1) return reason(failed[0]);
  return [
    t("my_questions.toasts.drafts_not_saved", { numbers: failed.map((item) => item.index + 1).join(", ") }),
    ...[...new Set(failed.map(reason))],
  ].join(" ");
};
